<template>
  <!-- Slider -->
  <section class="slider slider--product">
    <!-- H2 -->
    <h2>{{ title }}</h2>

    <!-- VueSlickCarousel -->
    <VueSlickCarousel v-bind="settings">
      <a
        class="slider-content"
        v-for="(item, index) in matchedProfiles"
        v-bind:key="index"
        :href="item.link"
        target="_blank"
      >
        <div class="imagelink">
          <img alt :src="require(`@/assets/img/${item.image}`)" />
        </div>
        <span class="textlink textlink--primary textlink--plain" v-html="item.heading"></span>
        <p>{{ item.text }}</p>
      </a>
    </VueSlickCarousel>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import profiles from '@/data/profiles.json';

export default {
  name: 'SliderProducts',
  components: {
    VueSlickCarousel,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    const matchedProfiles = profiles[this.$props.type];
    return {
      matchedProfiles,
      settings: {
        arrows: true,
        dots: false,
        edgeFriction: 0,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 250,
        draggable: true,
        touchThreshold: 10,
        variableWidth: true,
      },
    };
  },
};
</script>
